var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#1A1A1A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3680_2582)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9941 25H32.8453C32.569 25.0086 32.2963 25.065 32.0392 25.1667L31.9685 25.1946C30.8633 25.6301 27.6296 26.8255 26.8242 27.6309C25.6303 28.825 25.0813 30.3077 25.0083 31.9854C24.9268 33.86 25.4554 35.8117 26.1523 37.5358C27.9187 41.906 31.2354 46.1445 34.546 49.4551C37.8566 52.7656 42.0947 56.0824 46.4646 57.8488C48.0802 58.502 49.8776 59 51.632 59C51.7598 59 51.8875 58.9973 52.0153 58.9919C53.6926 58.9188 55.1762 58.3702 56.3698 57.1764C57.18 56.3663 58.3697 53.1444 58.8053 52.0343L58.8332 51.9632C59.0449 51.4351 59.0581 50.8482 58.8703 50.3112C58.6825 49.7741 58.3065 49.3233 57.8119 49.0422L51.9972 45.6855C51.4522 45.3721 50.8051 45.2874 50.1978 45.4501C49.5905 45.6128 49.0724 46.0096 48.7571 46.5536C48.1822 47.5497 47.3107 48.3579 46.154 48.5943C45.6102 48.713 45.047 48.7113 44.5039 48.5893C43.9608 48.4674 43.451 48.228 43.0102 47.8882C41.7189 46.9186 40.4873 45.795 39.3461 44.6542C38.205 43.5133 37.0813 42.2818 36.1122 40.9907C35.7721 40.5499 35.5327 40.0399 35.4107 39.4967C35.2886 38.9535 35.287 38.3902 35.4059 37.8463C35.6427 36.69 36.451 35.8186 37.4469 35.2438C37.991 34.9287 38.388 34.4106 38.5508 33.8032C38.7135 33.1958 38.6287 32.5487 38.315 32.0037L34.958 26.1893C34.7598 25.8396 34.4751 25.5466 34.1313 25.3383C33.7874 25.1301 33.3959 25.0136 32.9941 25Z",
    fill: "#743FAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3680_2582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.29a44bcde4b809d24d242ecd06520092.svg";
export { ForwardRef as ReactComponent };